import React, { PureComponent } from 'react'
import cn from 'classnames'
import { renderChildren } from '../children'

interface AnimationHandlerProps {
  animating?: boolean
  important?: boolean
  children: React.ReactElement | React.ReactElement[]
  type?:
    | 'zoom'
    | 'ken-burns'
    | 'lift'
    | 'zoom-tile'
    | 'show'
    | 'show-delayed'
    | 'hide'
    | 'hide-delayed'
}

export default class AnimationHandler extends PureComponent<AnimationHandlerProps> {
  static defaultProps = {
    type: 'zoom',
  }

  render() {
    const { animating, children, important, type, ...restProps } = this.props

    const classes = cn({
      'mc-animation': true,
      [`mc-animation--${type}`]: type,
      'mc-animation--animating': animating,
      'mc-animation--important': important,
    })

    return renderChildren(children, {
      className: classes,
      ...restProps,
    })
  }
}
